// validateCardNumber.js

/**
 * تبدیل ارقام فارسی و عربی به انگلیسی و پاکسازی کاراکترهای غیرعددی
 */
export const normalizeCardNumber = (cardNumber) => {
    if (!cardNumber) return "";
    return String(cardNumber)
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/\D/g, ""); // حذف فاصله، خط تیره و هر کاراکتر غیرعدد
};

/**
 * اعتبارسنجی شماره کارت بانکی با استفاده از الگوریتم لوهن (Luhn)
 * @param {string|number} cardNumber
 * @returns {boolean}
 */
export const isValidCardNumber = (cardNumber) => {
    const cleaned = normalizeCardNumber(cardNumber);

    // شماره کارت شتاب باید دقیقاً ۱۶ رقم باشد
    if (cleaned.length !== 16) {
        return false;
    }

    let sum = 0;
    for (let i = 0; i < 16; i++) {
        let digit = parseInt(cleaned[i], 10);

        // ارقام در جایگاه‌های با اندیس زوج (اول، سوم، پنجم، ...) در ۲ ضرب می‌شوند
        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9) {
                digit -= 9;
            }
        }
        sum += digit;
    }

    // اگر باقیمانده تقسیم مجموع بر ۱۰ برابر صفر باشد، کارت معتبر است
    return sum % 10 === 0;
};

export default isValidCardNumber;
